package com.appcreator.blueprint.core.properties

import kotlinx.serialization.Serializable

@Serializable
data class MaterialIcon(
    val name: String,
    val code: String
)